export const ConfigSplitter = '.';
